/**
 * Íconos SVG del flujo premium (procesos de orden).
 * Bucket: `s3://pico-imports-assets/icons/` (cuenta AWS pico: `aws s3 ls s3://pico-imports-assets/icons/ --profile pico`).
 * URLs HTTPS de lectura pública (mismo host que otros assets BrandFactory en la app).
 */
export const PREMIUM_FLOW_PROCESS_ICON_URL_COTIZACION =
    'https://pico-imports-assets.s3.amazonaws.com/icons/cotizacion.svg';

/** Cotización cuando el flujo incluye Coupa (primer proceso Coupa). */
export const PREMIUM_FLOW_PROCESS_ICON_URL_COTIZACION_COUPA =
    'https://pico-imports-assets.s3.amazonaws.com/icons/coupa-gray.svg';

export const PREMIUM_FLOW_PROCESS_ICON_URL_ORDEN_DE_COMPRA =
    'https://pico-imports-assets.s3.amazonaws.com/icons/precotizacion.svg';

export const PREMIUM_FLOW_PROCESS_ICON_URL_ENTREGA =
    'https://pico-imports-assets.s3.amazonaws.com/icons/producto-entregado.svg';

export const PREMIUM_FLOW_PROCESS_ICON_URL_FACTURA =
    'https://pico-imports-assets.s3.amazonaws.com/icons/orden-de-pago.svg';

export const PREMIUM_FLOW_PROCESS_ICON_URL_COMPLETADO =
    'https://pico-imports-assets.s3.us-east-1.amazonaws.com/pico-assets/SVG/LOGO_GRAY.svg';
